import { LEAVE_REQUEST,LEAVE_REQUEST_ERROR, LEAVE_REQUEST_SUCCESS,FORM_REFRESH } from "../actionType/type";

const initialState = {
    data: null,
    isLoading: false,
    refreshPage:false
};

export const manageLeaveReducer = (state=initialState,action) => {
    let object;
    switch (action.type) {
        case LEAVE_REQUEST:
            object = {
                ...state,
                isLoading: true,
              }
            break
        case LEAVE_REQUEST_ERROR:
            object = {
                ...state,
                isLoading:false
            }
            break
        case LEAVE_REQUEST_SUCCESS:
            object = {
                ...state,
                data:action.payload,
                isLoading:false
            }
            break
        case FORM_REFRESH:
            object = {
                ...state,
                refreshPage:!state.refreshPage
            }
            break
    
        default:
            object = state
            break
    }
    
    return object
}